var React = require('react');

function IcCheckComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-check"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M7.16477 11.9785L14.0475 5.09874L14.7979 5.84945L7.16445 13.4796L3.20851 9.52193L3.95922 8.77154L7.16477 11.9785Z","fill":"#006736"})));
}

IcCheckComponent.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = IcCheckComponent;

IcCheckComponent.default = IcCheckComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/DetailsModalV2/images/ic-check.component.svg
// module id = 692
// module chunks = 0